const img = require('./puff-geosecma-mina_sidor_2297aed2c0f9f7cb3711e27e95f1e5ed.png').default; export default img;